/**
 * Sleep utility for async functions.
 *
 * Example:
 * ```
 * async () => {
 *   console.log('sweet dreams');
 *   await sleep(8 * 3600 * 1000);
 *   console.log('good morning');
 * }
 * ```
 */
export function sleep(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
}
